import React from 'react';
import styled from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button/index';

const NavLink = (props) => (
  <Button
    {...props}
    nav
  />
);

export default styled(NavLink).attrs({ link: true })``;
